module.exports = __webpack_public_path__ + "img/languageScore4.342fab11.png";